var e=typeof document=="object"&&document.all,d=typeof e>"u"&&e!==void 0,l={all:e,IS_HTMLDDA:d};export{l as default};
